define('home/views/FollowerCollectionView',[
    'underscore',
    'jquery',

    'core/strings',
    'core/bus',

    'home/views/FollowerCardView',
    'home/views/common/FetchableCollectionView',
], function (
    _,
    $,

    strings,
    bus,

    FollowerCardView,
    FetchableCollectionView
) {
    'use strict';

    var gettext = strings.get;

    /**
     * A user's followers
     * NOTE: does not inherit from UserCollectionView because that class contains
     * behavior (like not removing an item from the view when removed from the
     * collection) that does not apply here.
     */
    return FetchableCollectionView.extend({
        initialize: function (options) {
            FetchableCollectionView.prototype.initialize.call(this, options);

            // The user to whom this collection of followers belongs
            this.user = options.user;
        },

        events: _.defaults({
            'click [data-action=remove-follower]': 'removeFollower',
        }, FetchableCollectionView.prototype.events),

        itemView: FollowerCardView,

        itemViewOptions: function () {
            return {
                showRemoveButton: this.user.isSessionUser(),
            };
        },

        removeFollower: function (evt) {
            if (!this.user.isSessionUser())
                return;

            evt.preventDefault();

            var $removeButton = $(evt.currentTarget);
            var whom = $removeButton.attr('data-user');
            var follower = this.collection.findWhere({ id: whom });

            var confirm = window.confirm(strings.interpolate(
                gettext('Remove %(follower)s as a follower?'), {
                    follower: follower.getDisplayName(),
                }
            ));

            if (!confirm)
                return;

            this.collection.remove(follower);

            bus.trigger('removeFollower', follower);

            return this.user.removeFollower(follower);
        },
    });
});

